import { putTagManagerWithDataLayer } from '@utils/tagManagerUtil';
import {
  DECISION_CLICK_TRACKER,
  DECISION_IMP_TRACKER,
  ADD_TO_WISHLIST,
  HOME,
  SEARCH,
  MOLOCO_PAGE_VIEW,
} from '@constants/moloco/molocoSpec';
import { uuidv4 } from '@utils/commonUtils';
import { getMolocoCustNo } from '@utils/domainUtil';
import { getCookieWckDisplayMktSID } from '@wconcept/wconcept-common/utils/cookie';

export const sendMolocoAddToWish = async (
  isNativeAppBoth: boolean,
  custNo: string,
  itemCd: string,
  amount: number,
  pageId: string
) => {
  const dataLayer = ADD_TO_WISHLIST;
  dataLayer.molocoData.id = uuidv4();
  const userId = await getMolocoCustNo(false, custNo);
  dataLayer.molocoData.session_id = encodeURIComponent(
    await getCookieWckDisplayMktSID()
  );
  dataLayer.molocoData.user_id = userId || '';
  dataLayer.molocoData.channel_type = isNativeAppBoth ? 'APP' : 'SITE';
  dataLayer.molocoData.timestamp = new Date().getTime();
  dataLayer.molocoData.items[0].id = itemCd || '';
  dataLayer.molocoData.items[0].price.amount = amount || 0;
  dataLayer.molocoData.items[0].quantity = 1;
  dataLayer.molocoData.page_id = pageId;
  if (!dataLayer.molocoData.user_id) {
    delete dataLayer.molocoData.user_id;
  }
  // 앱웹 구분 없이 gtm 트리거 호출
  putTagManagerWithDataLayer(isNativeAppBoth, dataLayer);
};

export const sendMolocoHome = async (
  isNativeAppBoth: boolean,
  custNo: string,
  pageId: string
) => {
  const dataLayer = HOME;
  dataLayer.molocoData.id = uuidv4();
  const userId = await getMolocoCustNo(false, custNo);
  dataLayer.molocoData.session_id = encodeURIComponent(
    await getCookieWckDisplayMktSID()
  );
  dataLayer.molocoData.user_id = userId || '';
  dataLayer.molocoData.channel_type = isNativeAppBoth ? 'APP' : 'SITE';
  dataLayer.molocoData.timestamp = new Date().getTime();
  dataLayer.molocoData.page_id = pageId;
  if (!dataLayer.molocoData.user_id) {
    delete dataLayer.molocoData.user_id;
  }
  // 앱웹 구분 없이 gtm 트리거 호출
  putTagManagerWithDataLayer(isNativeAppBoth, dataLayer);
};

export const sendMolocoSearch = async (
  isNativeAppBoth: boolean,
  custNo: string,
  keyword: string,
  pageId: string
) => {
  const dataLayer = SEARCH;
  dataLayer.molocoData.id = uuidv4();
  const userId = await getMolocoCustNo(false, custNo);
  dataLayer.molocoData.session_id = encodeURIComponent(
    await getCookieWckDisplayMktSID()
  );
  dataLayer.molocoData.user_id = userId || '';
  dataLayer.molocoData.channel_type = isNativeAppBoth ? 'APP' : 'SITE';
  dataLayer.molocoData.timestamp = new Date().getTime();
  dataLayer.molocoData.page_id = pageId;
  dataLayer.molocoData.search_query = keyword;
  if (!dataLayer.molocoData.user_id) {
    delete dataLayer.molocoData.user_id;
  }
  // 앱웹 구분 없이 gtm 트리거 호출
  putTagManagerWithDataLayer(isNativeAppBoth, dataLayer);
};

export const sendMolocoDecisionClickTracker = (
  isNativeAppBoth: boolean,
  url: string
) => {
  const dataLayer = DECISION_CLICK_TRACKER;
  dataLayer.molocoData = url;
  // 앱웹 구분 없이 gtm 트리거 호출
  putTagManagerWithDataLayer(isNativeAppBoth, dataLayer);
};

export const sendMolocoPageView = async (
  isNativeAppBoth: boolean,
  custNo: string,
  pageId: string
) => {
  const dataLayer = MOLOCO_PAGE_VIEW;
  dataLayer.molocoData.id = uuidv4();
  const userId = await getMolocoCustNo(false, custNo);
  dataLayer.molocoData.session_id = encodeURIComponent(
    await getCookieWckDisplayMktSID()
  );
  dataLayer.molocoData.user_id = userId || '';
  dataLayer.molocoData.channel_type = isNativeAppBoth ? 'APP' : 'SITE';
  dataLayer.molocoData.timestamp = new Date().getTime();
  dataLayer.molocoData.page_id = pageId;
  if (!dataLayer.molocoData.user_id) {
    delete dataLayer.molocoData.user_id;
  }
  // 앱웹 구분 없이 gtm 트리거 호출
  putTagManagerWithDataLayer(isNativeAppBoth, dataLayer);
};

export const sendMolocoImpTracker = (
  isNativeAppBoth: boolean,
  url?: string[]
) => {
  const dataLayer = DECISION_IMP_TRACKER;
  if (url) {
    dataLayer.molocoData = url;
  }
  // 앱웹 구분 없이 gtm 트리거 호출
  putTagManagerWithDataLayer(isNativeAppBoth, dataLayer);
};
